import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import SmartSuppChat from './components/SmartSuppChat';


const RouteLoadingFallback = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 100px)', paddingTop: '50px' }}> {/* Adjust height/padding as needed */}
    <div className="spinner" style={{
         border: '4px solid #f3f3f3',
         borderTop: '4px solid #3498db',
         borderRadius: '50%',
         width: '40px',
         height: '40px',
         animation: 'spin 1s linear infinite'
        }}>
    </div>    
  </div>
);

// --- Lazy Load Page Components ---
const LoginPage = lazy(() => import('./pages/login'));
const ActivateAccountPage = lazy(() => import('./pages/ActivateAccountPage'));
const ForgotPassword = lazy(() => import('./pages/ForgotPassword'));
const ResetPassword = lazy(() => import('./pages/ResetPassword'));

// Protected Pages
const Index = lazy(() => import('./pages/index'));
const Traffic = lazy(() => import('./pages/traffic'));
const Withdrawal = lazy(() => import('./pages/withdrawal'));
const History = lazy(() => import('./pages/history'));
const Membership = lazy(() => import('./pages/membership'));
const Cert = lazy(() => import('./pages/cert'));
const Event = lazy(() => import('./pages/event'));
const CheckIn = lazy(() => import('./pages/checkin'));
const FinancialInfo = lazy(() => import('./pages/financialinfo'));
const EditProfile = lazy(() => import('./pages/editprofile'));
const ContactPage = lazy(() => import('./pages/ContactPage'));


const NotFoundPage = () => (
    <div style={{ textAlign: 'center', marginTop: '100px' }}>
        <h2>404 - Page Not Found</h2>
        <p>Sorry, the page you are looking for does not exist.</p>
    </div>
);

// ---------------------------------------------

function App() {
  return (
    <AuthProvider>
      <Router>
        
        <Suspense fallback={<RouteLoadingFallback />}>
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/activate" element={<ActivateAccountPage />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            {/* Route expects a token parameter in the URL */}
            <Route path="/reset-password" element={<ResetPassword />} />

            {/* Protected Routes */}
            <Route path="/" element={ <ProtectedRoute> <Index /> </ProtectedRoute> } />
            <Route path="/traffic" element={ <ProtectedRoute> <Traffic /> </ProtectedRoute> } />
            <Route path="/history" element={ <ProtectedRoute> <History /> </ProtectedRoute> } />
            <Route path="/membership" element={ <ProtectedRoute> <Membership /> </ProtectedRoute> } />
            <Route path="/cert" element={ <ProtectedRoute> <Cert /> </ProtectedRoute> } />
            <Route path="/contact" element={ <ProtectedRoute> <ContactPage /> </ProtectedRoute>} />
            <Route path="/event" element={ <ProtectedRoute> <Event /> </ProtectedRoute> } />
            <Route path="/checkin" element={ <ProtectedRoute> <CheckIn /> </ProtectedRoute> } />
            <Route path="/withdrawal" element={ <ProtectedRoute> <Withdrawal /> </ProtectedRoute> } />
            <Route path="/wallet" element={ <ProtectedRoute> <FinancialInfo /> </ProtectedRoute> } />
            <Route path="/edit-profile" element={ <ProtectedRoute> <EditProfile /> </ProtectedRoute>} />

            {/* Catch-all 404 Route */}
            <Route path="*" element={<NotFoundPage />} />

          </Routes>
        </Suspense>
        <SmartSuppChat />
      </Router>
    </AuthProvider>
    
  );
}

export default App;